import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProductCard from "../../components/ProductCard/ProductCard";
import { AiOutlineHome } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

function CollectionView() {
  const { collectionName } = useParams();
  const collection_name = collectionName.replace(/-/g, " ");
  const baseURL = "https://karstar.in/";
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // STATES
  const [collectionItems, setCollectionItems] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [sortOption, setSortOption] = useState("low-to-high");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // SCROLL TO TOP
  useEffect(() => {
    scrollToTop();
  }, [navigate]);

  // FETCH PRODUCTS
  useEffect(() => {
    setIsLoading(true);
    const sessionId = sessionStorage.getItem("sessionId");
    const username = sessionStorage.getItem("username");

    if (username) {
      fetchProduct("na", username, collection_name);
    } else {
      fetchProduct(sessionId || "na", "na", collection_name);
    }
  }, [collection_name]);

  const fetchProduct = async (ipadd, email, collectionName) => {
    try {
      const response = await axios.get(
        `${baseURL}api/client_api/collections/getcollections/index.php`,
        {
          params: {
            name: collectionName,
            ipadd: ipadd,
            email: email,
          },
        }
      );

      const fetchedItem = response.data;

      // Extract unique collections from API
      // Extract unique categories
      const collectionSet = new Set();
      fetchedItem.forEach((item) => {
        if (item.collection && Array.isArray(item.collection)) {
          item.collection.forEach((col) => collectionSet.add(col));
        }
      });

      // Convert to array & sort A → Z
      let collections = Array.from(collectionSet).sort((a, b) =>
        a.localeCompare(b)
      );

      // Find "All Products"
      const allProductsIndex = collections.findIndex(
        (c) => c.toLowerCase() === "all products"
      );

      // If exists, move it to top
      if (allProductsIndex !== -1) {
        const allProductsValue = collections[allProductsIndex];
        collections.splice(allProductsIndex, 1); // remove from current place
        collections.unshift(allProductsValue); // add at top
      }

      // Default category = "All Products" or first in list
      const defaultCategory = collections[0] || "";

      setCategoryList(collections);
      setSelectedCategory(defaultCategory);

      // Default sorting
      setCollectionItems(sortItems(fetchedItem, "low-to-high"));
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  // SORTING LOGIC
  const sortItems = (items, option) => {
    let sorted = [...items];

    switch (option) {
      case "low-to-high":
        sorted.sort(
          (a, b) =>
            Number(a.price[0].discountedPrice) -
            Number(b.price[0].discountedPrice)
        );
        break;

      case "high-to-low":
        sorted.sort(
          (a, b) =>
            Number(b.price[0].discountedPrice) -
            Number(a.price[0].discountedPrice)
        );
        break;

      case "recent":
        sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        break;

      case "oldest":
        sorted.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        break;

      case "sort-order":
        sorted.sort((a, b) => Number(a.sort_order) - Number(b.sort_order));
        break;

      default:
        break;
    }

    return sorted;
  };

  // APPLY SORT WHEN sortOption CHANGES
  useEffect(() => {
    if (collectionItems.length > 0) {
      setCollectionItems((prev) => sortItems(prev, sortOption));
    }
  }, [sortOption]);

  // CATEGORY FILTER LOGIC
  const filterByCategory = (items) => {
    if (selectedCategory === "all") return items;

    return items.filter(
      (item) => item.collection && item.collection.includes(selectedCategory)
    );
  };

  const filteredItems = filterByCategory(collectionItems);

  // BREADCRUMB COMPONENT
  const Breadcrumb = () => {
    return (
      <div className="breadcrumb-container mb-5">
        <div className="breadcrumb">
          <a href="/" className="breadcrumb-item text-black me-2">
            <AiOutlineHome size={20} />
          </a>
          <a href="/categories" className="breadcrumb-item text-black me-2">
            Collections
          </a>
          <div className="breadcrumb-item text-black me-2">
            {collectionName}
          </div>
        </div>

        {/* HEADER */}
        <Row className="align-items-center mb-3">
          <Col xs={12} className="mb-2 mb-md-0">
            <h1 className="text-black pt-2 fw-bold">{collectionName}</h1>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div>
      <div className="sectionView mt-3">
        <Container>
          <Breadcrumb />

          {isLoading ? (
            <div>Loading...</div>
          ) : filteredItems.length > 0 ? (
            <Row className="g-0">
              {filteredItems.map((item, index) => (
                <Col xs={6} md={6} lg={2} key={index}>
                  <ProductCard
                    item={item}
                    baseUrl={baseURL}
                    wishlist={item.in_wishlist}
                    cart={item.in_cart}
                    analyticsContext="collections_page"
                  />
                </Col>
              ))}
            </Row>
          ) : (
            <div>No products found.</div>
          )}
        </Container>
      </div>
    </div>
  );
}

export default CollectionView;
